<template>
  <PaymentRequestCreateForm :customer-id="customerId" />
</template>

<script setup lang="ts">
defineProps<{
  customerId?: string
}>()
</script>
